var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFish = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.444 0C14.82 0 9.91 3.423 7.177 6.352L1.719 2.224C.96 1.65-.171 2.26.023 3.14L1.533 10l-1.51 6.86c-.194.88.938 1.49 1.696.917l5.458-4.128C9.91 16.577 14.821 20 20.444 20 29.035 20 36 12 36 10S29.035 0 20.444 0zm5.464 11.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFish, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fish.fbe1d595.svg";
export { ForwardRef as ReactComponent };